import React from 'react';
import { motion } from 'framer-motion';
import {
  FaPython, FaDocker, FaAws, FaGitAlt, FaDatabase, FaChartBar,
  FaGithub, FaBrain, FaRobot, FaLayerGroup, FaVectorSquare, FaCloud
} from 'react-icons/fa';
import {
  SiTensorflow, SiPytorch, SiPandas, SiNumpy, SiMongodb,
  SiRedis, SiPostgresql, SiFastapi, SiFlask, SiApachespark,
  SiMlflow
} from 'react-icons/si';
import './Skills.css';

const skillCategories = [
  {
    code: '01',
    title: 'Programming Languages',
    icon: <FaPython />,
    skills: [
      { name: 'Python', icon: <FaPython /> },
    ],
  },
  {
    code: '02',
    title: 'Machine Learning',
    icon: <FaBrain />,
    skills: [
      { name: 'LangChain', icon: <FaRobot /> },
      { name: 'LangGraph', icon: <FaRobot /> },
      { name: 'TensorFlow', icon: <SiTensorflow /> },
      { name: 'PyTorch', icon: <SiPytorch /> },
      { name: 'scikit-learn', icon: null },
      { name: 'Deep Learning', icon: <FaBrain /> },
      { name: 'NLP', icon: <FaBrain /> },
      { name: 'LLM Fine-tuning', icon: <FaBrain /> },
    ],
  },
  {
    code: '03',
    title: 'Database',
    icon: <FaDatabase />,
    skills: [
      { name: 'PostgreSQL', icon: <SiPostgresql /> },
      { name: 'MongoDB', icon: <SiMongodb /> },
      { name: 'Redis', icon: <SiRedis /> },
    ],
  },
  {
    code: '04',
    title: 'Vector Database',
    icon: <FaVectorSquare />,
    skills: [
      { name: 'Pinecone', icon: null },
      { name: 'Chroma', icon: null },
    ],
  },
  {
    code: '05',
    title: 'Data Analysis',
    icon: <FaChartBar />,
    skills: [
      { name: 'Pandas', icon: <SiPandas /> },
      { name: 'NumPy', icon: <SiNumpy /> },
      { name: 'PySpark', icon: <SiApachespark /> },
      { name: 'PowerBI', icon: <FaChartBar /> },
      { name: 'Seaborn', icon: null },
      { name: 'Matplotlib', icon: null },
    ],
  },
  {
    code: '06',
    title: 'REST API Development',
    icon: <FaLayerGroup />,
    skills: [
      { name: 'FastAPI', icon: <SiFastapi /> },
      { name: 'Flask', icon: <SiFlask /> },
    ],
  },
  {
    code: '07',
    title: 'Containerization & Tracking',
    icon: <FaDocker />,
    skills: [
      { name: 'Docker', icon: <FaDocker /> },
      { name: 'MLflow', icon: <SiMlflow /> },
    ],
  },
  {
    code: '08',
    title: 'Version Control',
    icon: <FaGitAlt />,
    skills: [
      { name: 'Git', icon: <FaGitAlt /> },
      { name: 'GitHub', icon: <FaGithub /> },
    ],
  },
  {
    code: '09',
    title: 'Cloud Technologies',
    icon: <FaCloud />,
    skills: [
      { name: 'AWS EC2', icon: <FaAws /> },
      { name: 'AWS S3', icon: <FaAws /> },
      { name: 'AWS Redshift', icon: <FaDatabase /> },
      { name: 'AWS CloudWatch', icon: <FaAws /> },
    ],
  },
];

const Skills = () => {
  return (
    <section id="skills" className="skills">
      <div className="container">
        <div className="section-header">
          <span className="section-label">[ 04 // TECHNICAL CAPABILITIES ]</span>
          <h2 className="section-title">Skills &amp; Technologies</h2>
          <p className="section-subtitle">
            Core technologies, libraries, and infrastructure I leverage for building end-to-end intelligent systems.
          </p>
        </div>

        <div className="skills__grid">
          {skillCategories.map((cat, catIdx) => (
            <motion.div
              className="skills__category"
              key={cat.title}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: catIdx * 0.05, duration: 0.4 }}
            >
              <div className="skills__category-header">
                <div className="skills__category-meta">
                  <span className="skills__category-code">{cat.code}</span>
                  <span className="skills__category-icon">{cat.icon}</span>
                </div>
                <h3 className="skills__category-title">{cat.title}</h3>
              </div>
              <div className="skills__items">
                {cat.skills.map((skill) => (
                  <div className="skills__item" key={skill.name}>
                    {skill.icon && <span className="skills__icon">{skill.icon}</span>}
                    <span className="skills__name">{skill.name}</span>
                  </div>
                ))}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Skills;
